// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // TIPO DE AFILIADO
  {
    path: '/categories-conditions/list',
    name: 'categories-conditions-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/categoriesConditions/List.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_categories_conditions',
    },
  },
]

export default formTable
